// extracted by mini-css-extract-plugin
export default {"container":"Like_container__FIR9c"};